import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { authKeys } from '@core/react-query/features/auth'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCognitoLogin = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['cognitoLogin']
  >,
) => {
  return useMutation({
    ...authKeys.cognitoLogin,
    retry: 0,
    ...options,
  })
}
